import { useMutation } from 'react-query';
import Customers from '../../services/Customers';

export const useMoveToReclear = () =>
  useMutation(({ customerId }: { customerId: string }) => Customers.moveToReclear(customerId));
